module.exports = __webpack_public_path__ + "static/media/drop-slide-thumb-8.aecbc800.png";